import { Level } from './../../levels/services/level.types';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { Inventory, InventoryPagination } from './inventory.type';


@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  private baseUrl: string;
  private _inventory: BehaviorSubject<Inventory[] | null> = new BehaviorSubject(null);
  private _pagination: BehaviorSubject<InventoryPagination | null> = new BehaviorSubject(null);

  constructor(
    private httpClient: HttpClient
  ) {
    this.baseUrl = `${environment.apiURL}/inventories-managment`;
  }

  get inventories$(): Observable<Inventory[]> {
    return this._inventory.asObservable();
  }

  get pagination$(): Observable<InventoryPagination> {
    return this._pagination.asObservable();
  }


  save(data: any, file: File, levels: Level[] = [], coupns: string[] = []) {
    const endpoint: string = this.baseUrl + '/inventory';
    const formData: FormData = new FormData();
    formData.append('limit_user_shopping',data.limit_user_shopping);

    formData.append('img', file);
    formData.append('type_id', data.type_product);
    // formData.append('type', data.type_name);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('points', data.cost_points);

    formData.append('limit_level', data.limit ? '1' : '0');
    formData.append('status', data.status ? '1' : '0');

    if(data.limit) {        //Si tiene niveles
        const levelID: number[] = levels.map(item => item.id);
        formData.append('levels', levelID.join(','))
    }

    if(data.type_product !== 2) { //Form data pra merchandising
        formData.append('identifier', data.identification);
        formData.append('price', data.price_unit);
        formData.append('stock', data.stock);
    }else {                                     //Form data para cupones
        formData.append('brand', data.mark);
        formData.append('expiration_date', data.date_expiration);
        formData.append('terms_conditions', data.terms);
        formData.append('codes', coupns.join(','));
        formData.append('stock', data.stock_cupons);
    }

    return this.httpClient.post(endpoint, formData);
  }

  list(page: number = 0, size: number = 10, sort: string = 'name', order: 'asc' | 'desc' | '' = 'asc', search: string = ''):
  Observable<InventoryPagination> {

    const endpoint: string = this.baseUrl + '/inventory';
    return this.httpClient.get<InventoryPagination>(endpoint, {
        params: {
          page: '' + page,
          size: '' + size,
          sort,
          order,
          search
        }
    }).pipe(tap( res => {
        res.data.forEach(item => {
            item.cheked = false;
            item.open = false;
        });

        this._pagination.next(res);
        this._inventory.next(res.data);
    }));
  }

  delete(id: number) {

    const endpoint: string = this.baseUrl + '/inventory/' + id;
    return this.httpClient.delete(endpoint);
  }

  update(id: number, data: any, file: File | null, levels: Level[] = [], coupns: string[] = []) {

    
    const endpoint: string = this.baseUrl + '/inventory/' + id;
    const formData: FormData = new FormData();
    

    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('points', data.cost_points);
    formData.append('limit_level', data.limit ? '1' : '0');
    formData.append('status', data.status ? '1' : '0');

    if(file) formData.append('img', file);

    if(data.limit) {        //Si tiene niveles
        const levelID: number[] = levels.map(item => item.id);
        formData.append('levels', levelID.join(','))
    }

    if(data.type_product !== "Cupones" ) { //Form data pra merchandising
        formData.append('stock', data.stock);
        formData.append('identifier', data.identification);
        formData.append('price', data.price_unit);
        formData.append('limit_user_shopping',data.limit_user_shopping);
    }else {  
        // formData.append('type', data.type_product);                                   //Form data para cupones
        formData.append('brand', data.mark);
        formData.append('expiration_date', data.date_expiration);
        formData.append('terms_conditions', data.terms);
        formData.append('codes', coupns.join(','));
        formData.append('stock', data.stock);
    }    
    
    return this.httpClient.post(endpoint, formData);
  }

  disabledMany(data: any) {

    const endpoint: string = this.baseUrl + '/manyinventories/disabled';
    return this.httpClient.put(endpoint, data);
  }

  deleteMany(data: any) {

    const endpoint: string = this.baseUrl + '/manyinventories';
    return this.httpClient.post(endpoint, data);
  }

  listtypes(): Observable<any> {
    const endpoint: string = this.baseUrl + '/inventory/types';
    return this.httpClient.get<InventoryPagination>(endpoint)
  } 
}
